import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Circle, Path } from "react-native-svg";

export const IconKey2: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-outlined-radius-0-stroke-1-IconKey2"><Circle cx="15" cy="9" r="1.5" stroke="currentColor"/><Path d="M15 14.5C18.0376 14.5 20.5 12.0376 20.5 9C20.5 5.96243 18.0376 3.5 15 3.5C11.9624 3.5 9.5 5.96243 9.5 9C9.5 9.73961 9.64599 10.4451 9.91072 11.0893L3.5 17.5V20.5H6.5L8.5 18.5V16.5H10.5L12.9107 14.0893C13.5549 14.354 14.2604 14.5 15 14.5Z" stroke="currentColor" strokeLinecap="square"/></CentralIconBase>;
});

export default IconKey2;
